import React from 'react';
import DownArrow from '@material-ui/icons/ArrowDropDown';
import UpArrow from '@material-ui/icons/ArrowDropUp';
import moment from 'moment';
import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';

const ModalTopDetail = ({ styles, state, removeWeeks, onlyAtm }) => {
  const appReducer = useSelector((state) => state.appReducer);
  const UOAstate = useSelector((state) => state.UOAState);

  return (
    <div style={styles.boardModalDataContainer}>
      <div style={styles.boardModalDataLeft}>
        <h2
          style={
            appReducer.isMobile
              ? { fontSize: '1em', margin: '0px' }
              : { margin: '0px' }
          }
        >
          {' '}
          {UOAstate.modalRowData.Symbol} Options
        </h2>
        <div style={styles.stockPriceInfo}>
          <h3
            style={
              appReducer.isMobile
                ? { fontSize: '0.8em', margin: '0px' }
                : { margin: '0px' }
            }
          >
            ${UOAstate.modalRowData.spot.toFixed(2)}
          </h3>
          <span
            style={
              UOAstate.modalRowData.spotchg < 0
                ? styles.negPriceChange
                : styles.posPriceChange
            }
          >
            {UOAstate.modalRowData.spotchg < 0 ? (
              <DownArrow style={styles.downArrow} />
            ) : (
              <UpArrow style={styles.upArrow} />
            )}{' '}
            <span style={styles.priceChange}>
              ${Math.abs(UOAstate.modalRowData.spotchg).toFixed(2)}
            </span>
            ({Math.abs(UOAstate.modalRowData.spotchgpct).toFixed(2)}
            %)
          </span>
        </div>
        <p
          style={
            appReducer.isMobile
              ? { ...styles.modalDate, fontSize: '0.8em' }
              : styles.modalDate
          }
        >
          {moment(state.modalDate).format('MMM DD YYYY')}
        </p>
      </div>
      <div style={styles.boardModalDataRight}>
        <FormControlLabel
          style={{
            height: '20px',
            fontWeight: 'bold',
            marginBottom: '5px',
          }}
          control={
            <Checkbox
              disabled={state.modalLoader}
              sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: 10.6,
                  boxShadow: '0.1px 0.1px 0.5px 0.1px',
                },
              }}
              checked={state.removeWeeks}
              onChange={removeWeeks}
            />
          }
          label={
            <Typography
              style={
                appReducer.isMobile
                  ? { ...styles.checkBoxText, lineHeight: '10px' }
                  : styles.checkBoxText
              }
            >
              Remove next 2 weeks
            </Typography>
          }
        />
        <FormControlLabel
          style={{ height: '20px', fontWeight: 'bold' }}
          control={
            <Checkbox
              disabled={state.modalLoader}
              sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: 10.6,
                  boxShadow: '0.1px 0.1px 0.5px 0.1px',
                },
              }}
              checked={state.onlyAtm}
              onChange={onlyAtm}
            />
          }
          label={
            <Typography
              style={
                appReducer.isMobile
                  ? { ...styles.checkBoxText, lineHeight: '10px' }
                  : styles.checkBoxText
              }
            >
              Only ATM & OTM Options
            </Typography>
          }
        />
      </div>
    </div>
  );
};
export default ModalTopDetail;



// WEBPACK FOOTER //
// ./src/components/Modals/UOAModal/components/ModalTopDetail.jsx